import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLargeScreen)
    ? _renderSlot(_ctx.$slots, "large", { key: 0 })
    : _renderSlot(_ctx.$slots, "small", { key: 1 })
}